import React from "react";

export default function LandingBanner( { bannerSrc, height="60vh" } ) {
  const imgSrc = bannerSrc || 'https://on-the-strip-ticketing.s3.us-west-1.amazonaws.com/banners/mainHeader.jpg';

  return (
    <div 
      className={`relative w-full overflow-hidden`}
      style={{ height: height }}
    >
      {/* Background image */}
      <img
        src={imgSrc}
        alt="Las Vegas Strip"
        className="absolute top-0 left-0 w-full h-full object-cover opacity-[0.7]"
      />

      {/* Overlay content */}
      
    </div>
  );
}
